import { FC, Fragment, useEffect, useRef, useState } from 'react'
import { Link } from 'react-scroll'
import style from './navbar.module.css'
import { TRest } from '../../utils/typesFromBackend'
import { ILink } from '../../utils/types'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Swiper as SwiperClass } from 'swiper/types'
import { fixNavbarUnderSales } from '../../helpers/fixNavbarUnderSales'

interface INavbar {
  data: ILink[]
  rest: TRest
}

const Navbar: FC<INavbar> = ({ data, rest }) => {
  const [numberSlides, setNumberSlides] = useState(0)

  const [activeIndex, setActiveIndex] = useState<number>(0)
  const [open, setOpen] = useState<boolean>(false)
  const [windowInnerWidth, setWindowInnerWidth] = useState<number>(
    -window.innerWidth
  )
  const [leftValue, setLeftValue] = useState<number>(-window.innerWidth)
  const [display, setDispaly] = useState<string>('none')
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass | null>(null)

  const backgroundCarousel = {
    background: rest.colorsSchema_id.backgroundCarousel,
    borderTop: `1px solid ${rest.colorsSchema_id.borderCarousel}`,
    borderBottom: `1px solid ${rest.colorsSchema_id.borderCarousel}`
  }

  // делаем рефы
  const groupSquareRef = useRef<HTMLDivElement | null>(null)
  const sliderDivRef = useRef<HTMLDivElement | null>(null)

  //  вызов функции для закрепления Navbar под Sales
  useEffect(() => {
    sliderDivRef !== null &&
      groupSquareRef !== null &&
      fixNavbarUnderSales(sliderDivRef, groupSquareRef)
  }, [sliderDivRef.current, groupSquareRef.current])

  useEffect(() => {
    setNumberSlides(data.length)
  }, [data])

  // Функция для перемещения к указанному слайду при клике
  const handleClick = (index: number): void => {
    setActiveIndex(index)
  }

  // когда модалка open - скрываем скролл
  useEffect(() => {
    const body = document.querySelector('body')
    if (body != null) {
      body.style.overflow = open ? 'hidden' : 'auto'
    }
  }, [open])

  useEffect(() => {
    if (open) {
      setTimeout(() => setWindowInnerWidth(0), 0)
      setTimeout(() => setLeftValue(window.innerWidth - 60), 0)
      setDispaly('block')
    } else {
      setWindowInnerWidth(-window.innerWidth)
      setLeftValue(-window.innerWidth)
      setTimeout(() => setDispaly('none'), 300)
    }
  }, [open])

  return numberSlides > 0 ? (
    <>
      {/* выезжающее слева меню */}
      <div
        style={{
          background: `${rest.colorsSchema_id.leftMenuBgColor}`,
          display: `${display}`,
          left: `${windowInnerWidth}` + 'px',
          overflowX: 'hidden'
        }}
        className={style.popup}
      >
        {/* крестик закрытия левого меню */}
        <div
          className={style.popupOpen}
          style={{
            position: 'fixed',
            left: `${leftValue}` + 'px',
            top: '10px',
            display: `${display}`
          }}
          onClick={() => setOpen(false)}
        >
          {/* SVG крестика ? */}
          <svg
            style={{ cursor: 'pointer' }}
            width='33'
            height='34'
            viewBox='0 0 33 34'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M16.4999 31.1668C10.9361 31.17 5.91861 27.7184 3.78897 22.4225C1.65933 17.1266 2.8373 11.0303 6.77318 6.97851C10.2482 3.39818 15.3132 1.99989 20.0602 3.31039C24.8071 4.62088 28.515 8.44106 29.7869 13.3319C31.0589 18.2227 29.7017 23.4412 26.2267 27.0215C23.6519 29.6863 20.1494 31.1789 16.4999 31.1668ZM5.49993 17.2437C5.56499 23.4788 10.5064 28.4885 16.5584 28.4552C22.6104 28.4215 27.4993 23.3573 27.4993 17.1218C27.4993 10.8864 22.6104 5.82219 16.5584 5.78851C10.5064 5.75516 5.56499 10.7649 5.49993 17V17.2437ZM12.9373 22.6667L10.9999 20.6692L14.5612 17L10.9999 13.3308L12.9387 11.3333L16.4999 15.0025L20.0612 11.3333L21.9999 13.3308L18.4387 17L21.9999 20.6692L20.0626 22.6667L16.4999 18.9975L12.9387 22.6667H12.9373Z'
              fill={rest.colorsSchema_id.mainColor}
            />
          </svg>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {/* массив ссылок левого слайдера категорий */}
          {data
            .filter((el) => el.title !== '')
            .map((link, index) => (
              <Fragment key={link._id + '-fragment'}>
                <div className={style.sliderItemParent}>
                  <Link
                    style={{
                      color: `${rest.colorsSchema_id.mainTextColor}`,
                      whiteSpace: 'normal'
                    }}
                    className={`${style['categories-parent']} ${style['categories-popup__category']}`}
                    onSetActive={() => {
                      setActiveIndex(index)
                      setOpen(false)
                    }}
                    to={link._id}
                    spy={true}
                    smooth={true}
                    offset={-150}
                    duration={500}
                    onClick={() => {
                      handleClick(index)
                    }}
                  >
                    {link.title}
                  </Link>
                </div>
                <hr
                  style={{
                    border: `1px solid ${rest.colorsSchema_id.stroke}`,
                    width: '99%',
                    opacity: '0.2'
                  }}
                />
              </Fragment>
            ))}
        </div>
      </div>

      {/* горизонтальная полоса меню */}
      {/* ID для всего слайдера */}
      <div id='sliderDiv' className={style.sliderDiv} ref={sliderDivRef}>
        <div
          style={backgroundCarousel}
          // ID для девяти квадратов
          id='groupSquare'
          ref={groupSquareRef}
          className={style.groupSquare}
          onClick={() => setOpen(true)}
        >
          {/* девять квадратов */}
          <div style={{ position: 'relative', top: '18px', left: '10px' }}>
            <div style={{ display: 'flex' }}>
              <div
                style={{ background: `${rest.colorsSchema_id.mainColor}` }}
                className={style.square}
              ></div>
              <div
                style={{ background: `${rest.colorsSchema_id.mainColor}` }}
                className={style.square}
              ></div>
              <div
                style={{ background: `${rest.colorsSchema_id.mainColor}` }}
                className={style.square}
              ></div>
            </div>
            <div style={{ display: 'flex', marginTop: '3px' }}>
              <div
                style={{ background: `${rest.colorsSchema_id.mainColor}` }}
                className={style.square}
              ></div>
              <div
                style={{ background: `${rest.colorsSchema_id.mainColor}` }}
                className={style.square}
              ></div>
              <div
                style={{ background: `${rest.colorsSchema_id.mainColor}` }}
                className={style.square}
              ></div>
            </div>
            <div style={{ display: 'flex', marginTop: '3px' }}>
              <div
                style={{ background: `${rest.colorsSchema_id.mainColor}` }}
                className={style.square}
              ></div>
              <div
                style={{ background: `${rest.colorsSchema_id.mainColor}` }}
                className={style.square}
              ></div>
              <div
                style={{ background: `${rest.colorsSchema_id.mainColor}` }}
                className={style.square}
              ></div>
            </div>
          </div>
        </div>
        <div
          className={style.navbarContainer}
          // ID для горизонтального меню
          id={'navbar-container'}
          style={backgroundCarousel}
        >
          <div className={style.sliderContainer}>
            {/* кнопки горизонтального меню */}
            <Swiper
              onSwiper={setSwiperInstance}
              slidesPerView='auto'
              initialSlide={activeIndex}
              touchRatio={2}
              freeMode={{ momentum: true }}
              enabled={true}
            >
              {data.map((link, index) => (
                <SwiperSlide key={link._id}>
                  <div
                    className={`${style.sliderItemParent} ${style.sliderItem}`}
                  >
                    <Link
                      to={link._id}
                      spy={true}
                      // smooth={true}
                      offset={-150}
                      duration={500}
                      // при клике на кнопку меняется активный слайд
                      onClick={() => handleClick(index)}
                      className={`${style['categories-parent']} ${style['categories-main__category']}`}
                      // прокрутка к выбранной категории
                      onSetActive={() => {
                        if (swiperInstance !== null) {
                          swiperInstance.slideTo(index)
                        }
                      }}
                      style={{
                        color:
                          index === activeIndex
                            ? rest.colorsSchema_id.buttonActiveTextColor
                            : rest.colorsSchema_id.textColorButtonCorousel,
                        background:
                          index === activeIndex
                            ? rest.colorsSchema_id.buttonActiveCarousel
                            : rest.colorsSchema_id.backgroundButtonCarousel,
                        visibility: link.title === '' ? 'hidden' : 'visible'
                      }}
                    >
                      {link.title}
                    </Link>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </>
  ) : null
}

export default Navbar
